<template>
  <v-card class="elevation-0">
    <v-card-title>
      <div class="headline font-weight-medium">
        SPT Details:
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout row wrap>
        <v-flex sm2>
          <v-btn v-show="showNewSpt" color="primary" @click="showSptAddDlg">
            <v-icon class="iconText">fa fa-plus</v-icon>
            New SPT
          </v-btn>
        </v-flex>
        <v-flex sm12 lg12 xs12>
          <view-spt :spt="spt"></view-spt>
        </v-flex>
        <v-flex sm12>
          <v-dialog v-model="dlgShow" scrollable persistent max-width="600px">
            <v-card>
              <v-card-title>
                <div class="title font-weight-medium">
                  New SPT
                </div>
              </v-card-title>
              <v-card-text>
                <v-textarea
                  v-model.trim="dlgModel.Diagnosis"
                  name="diagnosis"
                  label="Diagnosis:"
                  v-validate="{ required: true }"
                  :error="!!errors.has('diagnosis')"
                  :error-messages="errors.first('diagnosis')"
                  no-resize
                  rows="2"
                ></v-textarea>
                <v-dialog
                  ref="sptDtMenu"
                  v-model="sptDtMenu"
                  full-width
                  width="290px"
                >
                  <v-text-field
                    slot="activator"
                    name="sptDt"
                    label="SPT Registered Date:"
                    v-model="dlgModel.SptDate"
                    append-icon="fa fa-calendar-alt"
                    readonly
                    v-validate="{ required: true }"
                    :error="!!errors.has('sptDt')"
                    :error-messages="errors.first('sptDt')"
                  >
                  </v-text-field>
                  <v-date-picker
                    v-model="dlgModel.SptDate"
                    scrollable
                    @input="sptDtMenu = false"
                  >
                  </v-date-picker>
                </v-dialog>
                <allergens-comp :items="dlgModel.Allergens"></allergens-comp>
                <div v-show="submit.error">
                  <v-list two-line>
                    <v-list-tile>
                      <span class="red--text">{{ submit.message }}</span>
                    </v-list-tile>
                  </v-list>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat :disabled="submit.working" @click.native="clearDlg"
                  >Close</v-btn
                >
                <v-btn
                  @click.native="saveSptDlg"
                  color="blue darken-1"
                  flat
                  :loading="submit.working"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import WebH from "../../api/web";
import ViewSpt from "./ViewSpt";
import AllergensComp from "./Allergens";
export default {
  props: ["spt", "patient"],
  components: {
    ViewSpt,
    AllergensComp
  },
  data() {
    return {
      dlgShow: false,
      dlgModel: {},
      submit: {
        error: false,
        working: false,
        message: ""
      },
      sptDtMenu: false
    };
  },
  computed: {
    showNewSpt() {
      return !!this.patient.Id;
    }
  },
  methods: {
    clearDlg() {
      this.dlgShow = false;
      this.dlgModel = {};
      this.submit = {
        error: false,
        working: false,
        message: ""
      };
    },
    showSptAddDlg() {
      if (this.spt.Id) {
        this.dlgModel = {
          Diagnosis: this.spt.Diagnosis,
          SptDate: this.$options.filters.formatDateISO(this.spt.SptDate),
          PatientId: this.patient.Id,
          Allergens: JSON.parse(this.spt.Allergens)
        };
      } else {
        this.dlgModel = {
          Diagnosis: "",
          SptDate: "",
          PatientId: this.patient.Id,
          Allergens: []
        };
      }
      this.dlgShow = true;
    },
    async saveSptDlg() {
      if (this.dlgModel.Allergens.length < 1) {
        this.submit = {
          error: true,
          working: false,
          message: "You need to add allergens"
        };
        return;
      }
      const res = await this.$validator.validateAll();
      if (!res) return;
      this.api_addSpt(this.dlgModel);
    },
    async api_addSpt(data) {
      this.submit.working = true;
      const res = await WebH.Post("/spts", data);
      this.submit.working = false;
      if (res.Success) {
        // const newData = data;
        // newData.Allergens = JSON.stringify(data.Allergens);
        this.$emit("updateSpt", res.Data);
        //this.spt = res.Data;
        //this.spts.push(res.Data);
        this.$notify({ type: "info", text: "Successfully added new SPT" });
        this.clearDlg();
      } else {
        this.submit.error = true;
        this.submit.message = res.Data;
        this.submit.working = false;
      }
    }
  }
};
</script>

<style scoped></style>
